import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import SiChevronDown from '@/icons/SiChevronDown';
import SiChevronUp from '@/icons/SiChevronUp';
import { FC, PropsWithChildren, Suspense, useState } from 'react';
import { SidebarLink } from './SidebarLink';

interface Props {
  title: string;
  collapsible?: boolean;
  to: string;
  defaultExpanded?: boolean;
}

export const SidebarSubSection: FC<PropsWithChildren<Props>> = ({
  title,
  children,
  to,
  collapsible = false,
  defaultExpanded = false
}) => {
  const [expanded, setExpanded] = useState(!collapsible || defaultExpanded);

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex justify-between space-x-2">
        <SidebarLink to={to}>{title}</SidebarLink>
        {collapsible && (
          <div>
            <Button variant={ButtonVariant.Ghost} onClick={() => setExpanded(!expanded)}>
              {expanded ? <SiChevronUp className="text-lg" /> : <SiChevronDown className="text-lg" />}
            </Button>
          </div>
        )}
      </div>
      {expanded && (
        <Suspense>
          <div className="px-2">{children}</div>
        </Suspense>
      )}
    </div>
  );
};
